import AdminOverviewPage from '../../AdminOverviewPage';
import { useLegacyAppSession } from '../../contexts/LegacyAppSessionContext';

export default function AdminContainer() {
  const { currentUser } = useLegacyAppSession();
  return <AdminOverviewPage currentUser={currentUser} />;
}
